import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaDpProps.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(DPPROP)$/.test(type)
        },

        canWriteTree(map, node) {
            return false
        },

        getText(map, node) {
            return this.typeName(map, node.parent)
        },
    })
}
